import 'core-js/es6/array';
import 'core-js/es6/object';
import 'core-js/es7/array';
import 'core-js/es7/object';



// WEBPACK FOOTER //
// ./src/config/polyfills/polyfills.js